import { render, staticRenderFns } from "./partner-add-inventory.vue?vue&type=template&id=b694bb6a"
import script from "./partner-add-inventory.vue?vue&type=script&lang=js"
export * from "./partner-add-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports